module.exports = "/_next/static/images/c7fb06a5098f2aeb254f8e96b528fb9b-people-smile-at-home-lg@3x.jpg.webp";